/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KopiaRobocza } from '../../models/kopia-robocza';

export interface ApiWebInstytucjeNipRoboczeGet$Params {
  nip: string;

/**
 * Paginacja, końcowy rekord.
 */
  ilosc?: number;

/**
 * Paginacja, początkowy rekord.
 */
  od?: number;

/**
 * Po której kolumnie sortować.
 */
  orderByColumn?: any;

/**
 * Kierunek sortowania.
 */
  orderByDirection?: any;

/**
 * Opcjonalne do filtrowania.
 */
  uzytkownikGoAML?: string;
}

export function apiWebInstytucjeNipRoboczeGet(http: HttpClient, rootUrl: string, params: ApiWebInstytucjeNipRoboczeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KopiaRobocza>>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeNipRoboczeGet.PATH, 'get');
  if (params) {
    rb.path('nip', params.nip, {});
    rb.query('ilosc', params.ilosc, {});
    rb.query('od', params.od, {});
    rb.query('orderByColumn', params.orderByColumn, {});
    rb.query('orderByDirection', params.orderByDirection, {});
    rb.query('uzytkownikGoAML', params.uzytkownikGoAML, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<KopiaRobocza>>;
    })
  );
}

apiWebInstytucjeNipRoboczeGet.PATH = '/api/web/instytucje/{nip}/robocze';
